<template>
  <div>
    <v-bottom-sheet
      v-model="sheet"
    >
      <v-card
        tile
      >
        <div
          class="pa-4"
        >
          <note
            :note="note"
          />
        </div>

        <v-form
          @submit.prevent="submit"
        >
          <v-card-text>
            <v-textarea
              v-model="note.body"
              label="Admin-julkaisu"
              hide-details
              outlined
            />
          </v-card-text>

          <v-card-actions>
            <v-btn
              @click="submit"
              color="teal"
              dark
              block
            >
              Lähetä
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-bottom-sheet>

    <v-btn
      v-if="$currentUser.isAdmin"
      color="secondary"
      fab
      fixed
      left
      style="bottom: 72px;"
      @click="sheet = true"
    >
      <v-icon>
        note_add
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import Note from './Note.vue';

export default {
  components: {
    Note,
  },

  data: () => ({
    sheet: false,
    note: null,
  }),

  created() {
    this.resetNote();
  },

  methods: {
    ...mapWaitingActions('admin/notes', {
      createNote: 'creating note',
    }),

    async submit() {
      const payload = {
        note: {
          body: this.note.body,
        },
      };

      await this.createNote(payload);
      this.finally();
    },

    finally() {
      this.resetNote();
      this.sheet = false;
    },

    resetNote() {
      this.note = {
        backgroundColor: 'teal',
        body: '',
        cachedImagesCount: 0,
        cachedCommentsCount: 0,
        likesCount: 0,
      };
    },
  },
};
</script>
